import { useAppKit } from '@reown/appkit/react';

export const useConnect = () => {
  const { open } = useAppKit();
  return { connect: open };
};
